module.exports = {
  "country": "LT",
  "artist": "Donny Montell",
  "song": "Love Is Blind",
  "year": "2012",
  "place": "14",
  "spotify": "4DNIj6r4mKsZMnpATHf3ai"
};